import moment from "moment";
import React, { Component } from "react";
import { translate } from "react-i18next";
import AutocompleteForm from "../../components/AutocompleteForm";
import Button from "../../components/Button";
import InputForm from "../../components/InputForm";
import LabelForm from "../../components/LabelForm";
import SearchIcon from "../../components/SearchIcon";
import SelectForm from "../../components/SelectForm";
import ModalPersonSearch from "../../containers/generics/modal_person_search";
import ModalSearchFingerprint from "../../containers/offers/components/ModalSearchFingerprint";
import { getFormatHour } from "../../libs/functions";
import { convokePlacesOption, donationRules, donationTypeExtraction, donorsSearch, functionalCriterial, getDateHour, workSessions, workSessionsOption } from "../../libs/services";

class DonationData extends Component{
    constructor(props){
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.getDonationTypes = this.getDonationTypes.bind(this);
        this.onAutocompleteSeach = this.onAutocompleteSeach.bind(this);
        this.onAutocompleteChange = this.onAutocompleteChange.bind(this);
        this.openModalPersonSearch = this.openModalPersonSearch.bind(this);
        this.searchByFingerprint = this.searchByFingerprint.bind(this);
        this.closeSearchFingerprint = this.closeSearchFingerprint.bind(this);
        this.clear = this.clear.bind(this);
        this.getData = this.getData.bind(this);
        this.setData = this.setData.bind(this);

        this.state = {
            timestamp:"",
            day:"",
            hour:"",
            day_sesion_donation:"",
            day_sessions:[],
            convoke_places_id:"",
            convoke_places:[],
            donation_type_extraction_id:"",
            extraction_types:[],
            donation_type_id:"",
            donation_types:[],
            optionsAutocomplete:[],
            load_search:false,
            id:""
        }
    }

    async componentDidMount(){
        this.props.onRef(this);

        var hf_id = sessionStorage.getItem('health_facilities_id');
        var options = [];

        var response = await getDateHour();
        if(response !== undefined){
            var aux = response.split('|');
            var date = aux[0].split("/");
			var hours = getFormatHour(aux[1]);

            this.setState({ 
                timestamp: aux[0]+' '+aux[1],
                day:date[2]+'-'+date[1]+'-'+date[0],
                hour:hours
            });
        }

        response = await workSessions(hf_id);
        if(response !== undefined){
            options = [];
            response.forEach((res)=>
                options.push({
                    value:res.id,
                    text:res.type_value
                })
            );

            this.setState({ day_sessions: options });
        }

        response = await workSessionsOption(hf_id);
        if(response){
            this.setState({
                day_sesion_donation:response.id
            });
        }

        response = await convokePlacesOption('for_cells', hf_id);
        if(response !== undefined){
            options = [];
            response.forEach((res)=>
                options.push({
                    value:res.convoke_places.id,
                    text:res.convoke_places.name
                })
            );
            this.setState({ convoke_places: options });
        }

        response = await donationTypeExtraction('cells');
        if(response !== undefined && response !== null){
            options = [];
            response.forEach((res)=>
                options.push({
                    value:res.id,
                    text:res.donation_type_process
                })
            );

            this.setState({ extraction_types: options });
        }

        
    }

    async handleChange(e){
        var name = e.target.name;
        var value = e.target.value;

        await this.setState({[name]: value});

        if(name === 'donation_type_extraction_id'){
            if(value !== ""){
                await this.getDonationTypes(value);
            }
        }

        if(name === 'donation_type_id'){
            if(value !== ""){
                var value = parseInt(value);
                var index = this.state.donation_types.findIndex(item => item.value === value);
                if(index !== -1){
                    var show = false;
                    if(this.state.donation_types[index].patient){
                        show = true;                        
                    }

                    this.props.onChange({target:{name:'show_patient_data', value:show}});
                }
            }
        }
    }

    async getDonationTypes(id){
        var response = await donationRules(id);
        if(response){
            var options = [];
            response.forEach((res)=>{
                res.value = res.donation_type.id;
                res.text = res.donation_type_lookup;
                res.patient = res.donation_type.patient_required === 1;

                options.push(res);
            });
            this.setState({ donation_types: options });   
        }
    }

    async onAutocompleteSeach(query){
        this.setState({load_search:true});

        var response = await donorsSearch(query);
        if(response){
            if(response !== null){
                for (var i = 0; i < response.length; i++) {
                    
                    /* revisar en la base de datos el lastname1 y lastname2 ya que lastname1 contiene el lastname2*/

                    if(response[i].lastname2 !== undefined && response[i].lastname2 !== null && response[i].lastname2 !== ""){
                        response[i].values = response[i].lastname1 +' '+ response[i].lastname2+' '
                                            +response[i].names +' '+ 
                                            (response[i].birthday !== null ? response[i].birthday : '');
                    
                    }else{
                        response[i].values = response[i].lastname1 +' '+ response[i].names +' '+ 
                                            (response[i].birthday !== null ? response[i].birthday : '');
                    }

                    if(response[i].document_type_value !== null){							
                        response[i].values +=' '+response[i].document_type_value;
                        
                    }
                    if(response[i].document_number !== null){						
                        response[i].values +=' '+response[i].document_number;
                    }
                    response[i].id = response[i].donor_id;
                };
                
                this.setState({ optionsAutocomplete: response });
            }
        }

        this.setState({load_search:false});
    }

    onAutocompleteChange(values) {
	    let value = '';
	    if (values.length > 0) {
	      value = values[0];
	    }

	    this.props.onChange({
            target:{
                name:'blockFields', value:false 
            }
        });
	    this.props.onChange({
            target:{
                name:'checkEditData', value:false
            }
        });

        this.props.getInfo(value.id);
	}

    openModalPersonSearch(){
		this.modal_person_search.handleShow('Donador', 'donors');
	}

    searchByFingerprint(e){
		e.preventDefault();
		this.modal_search_fingerprint.handleShow();
	}

    closeSearchFingerprint(res){
		this.setState({optionsAutocomplete:[]});
		this.props.setInfoDonor(res);
	}

    clear(e){
		e.preventDefault();
		this.autocomplete.refs.offer_typeahead._instance.getInstance().clear();
		this.props.clearData();
	}

    getData(obj){
        obj = { ...obj, offering_cells: { 
            ...obj.offering_cells,
            work_session_id: this.state.day_sesion_donation,
            registration_date: this.state.day,
            registration_hour: this.state.hour,
            convoke_place_id: this.state.convoke_places_id,
            donation_type_extraction_id: this.state.donation_type_extraction_id,
            donation_type_id: this.state.donation_type_id,
            health_facility_id: sessionStorage.getItem('health_facilities_id')
        }};

        return obj;
    }

    async setData(item){
        var day = item.offering_cells.registration_date;
        var hour = item.offering_cells.registration_hour;
        var date = moment(item.offering_cells.registration_date).format('DD/MM/YYYY')+' '+
                    moment(item.offering_cells.registration_hour, 'HH:mm:ss.sssssss').format('HH:mm');

        await this.setState({
            day:day,
            hour:hour,
            timestamp:date,
            day_sesion_donation:item.offering_cells.work_session_id,
            convoke_places_id:item.offering_cells.convoke_place_id,
            donation_type_id:item.offering_cells.donation_type_id
        });
        
        await this.handleChange({target:{
            name:'donation_type_extraction_id', 
            value:item.offering_cells.donation_type_extraction_id
        }});
        
        await this.handleChange({target:{
            name:'donation_type_id', 
            value:item.offering_cells.donation_type_id
        }});
    }

    render(){
        const {t} = this.props;
        return(
            <fieldset>
                <legend>{this.props.title}</legend>
                <div className="col-xs-12 form-group no-padding">
                    <div className="col-xs-12 col-sm-2">
                        <LabelForm text={t('content.offers.form.timestamp')} />
                        <InputForm 
                            id="timestamp"
                            value={this.state.timestamp}
                            disabled={true}
                            required={false}
                            handleChange={this.handleChange}
                        />
                    </div>
                    <div className="col-xs-12 col-sm-2">
                        <LabelForm text={t('content.offers.form.day_session')} />
                        <SelectForm 
                            id="day_sesion_donation"
                            value={this.state.day_sesion_donation}
                            options={this.state.day_sessions}
                            handleChange={this.handleChange}
                            disabled={true}
                        />
                    </div>
                    <div className={this.props.agenda ? "col-xs-12 col-sm-3" : "col-xs-12 col-sm-4"}>
                        <LabelForm text={t('content.offers.form.convoke_place')} />
                        <SelectForm
                            id="convoke_places_id"
                            value={this.state.convoke_places_id}
                            options={this.state.convoke_places}
                            handleChange={this.handleChange}
                            required
                            //disabled={this.state.don_usr_clc.value === "NO"}
                        />
					</div>
                    <div className="col-xs-12 col-sm-2">
                        <LabelForm text={t('content.offers.form.extraction_type')} />
                        <SelectForm 
                            id="donation_type_extraction_id"
                            value={this.state.donation_type_extraction_id}
                            options={this.state.extraction_types}
                            handleChange={this.handleChange}
                            validate={this.props.validate}
                            required
                            disabled={!this.props.can_edit}
                        />
                    </div>

                    <div className="col-xs-12 col-sm-2">
                        <LabelForm text={t('content.offers.form.donation_type')} />
                        <SelectForm 
                            id="donation_type_id"
                            value={this.state.donation_type_id}
                            options={this.state.donation_types}
                            handleChange={this.handleChange}
                            validate={this.props.validate}
                            disabled={!this.props.can_edit}
                            required
                        />
                    </div>
                </div>
                <div className="col-xs-12 no-padding">
                    <div className="col-xs-12 col-sm-7">
                        <LabelForm text={t('content.generics.buttons.search')} />
                        <AutocompleteForm 
                            id="offer_search"
                            inputProps={{
                                id:"offer",
                                name:"offer"
                            }}
                            minLength={3}
                            maxLength={50}
                            handleSearch={this.onAutocompleteSeach}
                            handleChange={this.onAutocompleteChange}
                            placeholder="Buscar por apellidos más nombre o número de documento..."
                            options={this.state.optionsAutocomplete}
                            loading={this.state.load_search}
                            reference="offer_typeahead"
                            onRef={ref => this.autocomplete = ref}
                        />
                    </div>
                    <div className="col-xs-12 col-sm-1">
                        <SearchIcon 
                            actionSearch={this.openModalPersonSearch}
                        />
                    </div>
                    <div className="col-xs-12 col-sm-4">
                        <div className="col-xs-12 col-sm-8">
                            {this.props.don_hue_dig.value === "YES" &&
                                <Button 
                                    styles={{marginTop:"16px"}}
                                    class="btn-info button-min"
                                    action={this.searchByFingerprint}
                                    text="BUSCAR POR HUELLA"
                                />
                            }
                            <Button 
                                styles={{marginTop:"16px",marginLeft:"5px", marginLeft:'8px'}}
                                class="btn-second button-min"
                                action={this.clear}
                                text="LIMPIAR"
                            />
                        </div>
                    </div>
                </div>                
                <ModalPersonSearch 
                    {...this.props} 
                    waiting={this.props.waiting} 
                    updatePerson={this.onAutocompleteChange} 
                    onRef={ref => (this.modal_person_search = ref)} 
                />
                <ModalSearchFingerprint 
                    {...this.props} 
                    save={this.closeSearchFingerprint}
                    onRef={ref => (this.modal_search_fingerprint = ref)}
                />
            </fieldset>
        )
    }
}

export default translate('translations')(DonationData);